// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const PP_REQUEST_PAGE_DATA = 'PP_REQUEST_PAGE_DATA';
const PP_REQUEST_PAGE_DATA_SUCCESS = 'PP_REQUEST_PAGE_DATA_SUCCESS';

export {
  PP_REQUEST_PAGE_DATA,
  PP_REQUEST_PAGE_DATA_SUCCESS,
};
